export const isParentLoggedIn = () => {
  return Boolean(localStorage.getItem("parent_token"));
};
